
import { namespaceName } from "@/store/createStore";
import {
  ExerciseActions,
  UpdatePreferencesPayload,
} from "@/store/modules/exercise/types";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    animationDuration: { type: Number, required: true },
    disableAnimation: Boolean,
    counter: { type: Number, required: true },
  },

  methods: {
    toggleAnimation() {
      this.$store.dispatch(
        namespaceName("exercise", ExerciseActions.UpdatePreferences),
        {
          propName: "disableAnimation",
          value: !this.disableAnimation,
        } as UpdatePreferencesPayload
      );
    },
  },
});
